import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import Link from '../../Link';

const CardFunPairingComment = ({ author, image, title, url, variant }) => {
  return (
    <Link
      className={classnames('flex', 'lg:flex-row', {
        'flex-col': variant,
      })}
      to={url}
    >
      <div className="relative w-12 h-12 mr-4 lg:h-14 lg:w-14">
        <div className="absolute inset-0 z-10 border rounded-full border-liquorice" />
        <GatsbyImage
          alt={title}
          className="inset-0"
          image={getImage(image)}
          imgStyle={{ 'border-radius': '50%' }}
          style={{ position: 'absolute' }}
        />
      </div>
      <div
        className={classnames('flex', 'flex-col', 'flex-1', 'lg:mt-0', {
          'mt-2': variant,
        })}
      >
        <h5 className="stink-h5 text-hover">{title}</h5>
        <p className="mt-2 text-slate stink-footnote">{author}</p>
      </div>
    </Link>
  );
};

CardFunPairingComment.propTypes = {
  author: PropTypes.string,
  image: PropTypes.object,
  title: PropTypes.string,
  url: PropTypes.string,
  variant: PropTypes.bool,
};

export default CardFunPairingComment;
